import React from "react";
import "./SideBar.css";
import { Image, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "actions";
import { Navigation } from 'CommonComponent';

const SideBar = ({ ...rest }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const session = useSelector((state) => state.session);

  const userLogout = async (event) => {
    event.preventDefault();
    await dispatch(logout());
  };

  return (
    <>
      <div className="ps-4 py-5">
        <div className="px-4 py-3 side-bar position-relative">
          {(session.nested_menus) ?
            <Navigation
              component="div"
              pages={session.nested_menus}
            />
            : ''}

          <div className="position-absolute logout-btn bottom-0 mb-4 w-80">
            <Button
              className="font-13 font-weight-medium border-0"
              variant="none"
              onClick={userLogout}
            >
              {" "}
              <Image src="/assets/images/logout-icon.svg" /> Sign Out{" "}
            </Button>
          </div>
        </div>

      </div>


      {/*<div className="px-4 py-5">

        <div className="px-4 py-3 side-bar position-relative">
          <p className="font-14 font-weight-medium d-flex align-items-center mb-2">
          <Image
            src={theme === 'dark' ? '/assets/images/icon-ai-dark.svg' : '/assets/images/icon-ai.svg'}
            className="me-2"
            alt="AI Icon"
          />
            AI
          </p>
          <div className="side-bar-tabs">
            <div className="side_bar_margin sidebar-menu-line">

              workspace
            </div>
            <div className="side_bar_margin sidebar-menu-line">
              workspace
            </div>
            <div className="side_bar_margin sidebar-menu-line">
              workspace
            </div>
            <div className="side_bar_margin sidebar-menu-line">
              workspace
            </div>
            <div className="side_bar_margin">
              workspace
            </div>

          </div>
        </div>
      </div>*/}
    </>
  );
};

export default SideBar;

/**
  
  <p className="font-14 font-weight-medium d-flex align-items-center mb-2">
              <Image
                src={theme === 'dark' ? '/assets/images/user-manage-dark.svg' : '/assets/images/user-manage.svg'}
                className="me-2 user-icon"
              />
              Access Manage
            </p>
            <div>
              <div className="side_bar_margin sidebar-menu-line">
                
              </div>
            </div>
            <div>
              <div className="side_bar_margin sidebar-menu-line">
                {location.pathname === "/user" ? (
                  <Image
                    src="/assets/images/active.svg"
                    className="active-before"
                  />
                ) : (
                  <Image src="/assets/images/inactive.svg" />
                )}

                <Link to="/user"> 
                  <Button
                    variant="none"
                    className={`border-0 font-13 font-weight-normal text-secondary ${location.pathname === "/user"
                        ? "active-sidebar"
                        : ""
                      }`}
                  >
                    Users
                  </Button>
                </Link>
              </div>
            </div>
            <div>
              <div className="side_bar_margin sidebar-menu-line">
                {location.pathname === "/roles" ? (
                  <Image
                    src="/assets/images/active.svg"
                    className="active-before"
                  />
                ) : (
                  <Image src="/assets/images/inactive.svg" />
                )}

                <Link to="/roles">
                  <Button
                    variant="none"
                    className={`border-0 font-13 font-weight-normal text-secondary ${location.pathname === "/roles"
                        ? "active-sidebar"
                        : ""
                      }`}
                  >
                    Roles
                  </Button>
                </Link>
              </div>
            </div>
            <div className="">
              <div className="side_bar_margin object-before">
                {location.pathname === "/object" ? (
                  <Image
                    src="/assets/images/active.svg"
                    className="active-before"
                  />
                ) : (
                  <Image src="/assets/images/inactive.svg" />
                )}

                <Link to="/object">
                  <Button
                    variant="none"
                    className={`border-0 font-13 font-weight-normal text-secondary ${location.pathname === "/object"
                        ? "active-sidebar"
                        : ""
                      }`}
                  >
                    Objects
                  </Button>
                </Link>
              </div>
            </div>
            <div className="position-absolute logout-btn bottom-0 mb-4 w-80">
              <Button
                className="font-13 font-weight-medium border-0"
                variant="none"
                onClick={userLogout}
              >
                {" "}
                <Image src="/assets/images/logout-icon.svg" /> Sign Out{" "}
              </Button>
            </div>

 */
